import gql from 'graphql-tag';

export interface Input {
  tagId: string;
  organizationId: number;
}

export interface Data {
  id: string;
}

export const MUTATION = gql`
  mutation DeleteTag($id: Int!, $organizationId: Int!) {
    deleteTag(organizationId: $organizationId, id: $id) {
      id
    }
  }
`;
